import {ModalReducerNS} from 'module/Modal/reducer/ModalReducer';
import {PropertiesReducerNS} from 'module/Properties/reducer/PropertiesReducer';
import {PropertiesEpic} from 'module/Properties/epic/PropertiesEpic';
import {SessionInfoReducerNS} from 'module/SessionInfo/reducer/SessionInfoReducer';
import {SessionInfoEpic} from 'module/SessionInfo/epic/SessionInfoEpic';
import {persistStateToClientStorageEpic} from 'util/redux/ReduxStateUtil';
import {TopNavBarReducerNS} from 'module/TopNavBar/reducer/TopNavBarReducer';
import {ThemeEpic} from 'module/Theme/epic/ThemeEpic';
import {ThemeReducerNS} from 'module/Theme/reducer/ThemeReducerNS';
import {PropID} from 'module/Properties/enum/PropID';
import {NotiReducerNS} from 'module/Noti/reducer/NotiReducer';
import {NotiEpic} from 'module/Noti/epic/NotiEpic';
import {MenuReducerNS} from 'appmodule/home/reducer/MenuReducer';
import {MenuEpic} from 'appmodule/home/epic/MenuEpic';

export const commonReducers = {
	...PropertiesReducerNS,
	...SessionInfoReducerNS,
	...ThemeReducerNS,
	...MenuReducerNS,
	...TopNavBarReducerNS,
	...NotiReducerNS,
	...ModalReducerNS,
	_VERSION: (s?: number) => s || 0,
}

export const commonEpics = [
	SessionInfoEpic,
	ThemeEpic,
	PropertiesEpic,
	NotiEpic,
	persistStateToClientStorageEpic,
	MenuEpic,
]

export const commonProperties = [
	PropID.eventDialog_favDefault,
	PropID.evoApps_mailVertretungMaxAmount,
	PropID.evoApps_mailVertretungAllowFwd,
	PropID.evoApps_mailVertretungGlobalFwdSwitch,
	PropID.evoApps_notiButtonShowAlways,
]